module.exports = __webpack_public_path__ + "static/hike-min-3033d967560388245e99d30909feb61f.jpg";